import { handleActions } from '@housinganywhere/safe-redux';
import { Actions, ActionTypes } from './actions';

export const initialState = {
  isShowingAuthModal: false,
  isShowingMobileDrawer: false,
};

const reducer = handleActions<typeof initialState, ActionTypes, Actions>(
  {
    [ActionTypes.SHOW_MODAL]: _state => ({
      ..._state,
      isShowingAuthModal: true,
    }),
    [ActionTypes.HIDE_MODAL]: _state => ({
      ..._state,
      isShowingAuthModal: false,
    }),
    [ActionTypes.OPEN_MOBILE_DRAWER]: _state => ({
      ..._state,
      isShowingMobileDrawer: true,
    }),
    [ActionTypes.CLOSE_MOBILE_DRAWER]: _state => ({
      ..._state,
      isShowingMobileDrawer: false,
    }),
  },
  initialState,
);

export default reducer;
